import { createLogic } from 'redux-logic';
import { PRODUCT_URL, PRODUCT_URL_NEW_OPERATIONS } from 'utils/api';

import { toastr } from 'react-redux-toastr';
import { LOAD_PRODUCT } from '../constants/product';
import { LoadProductSuccess, LoadProductError } from '../actions/product';
import normalizeProduct, { rubiYieldFormatter } from '../models/product';

export default createLogic({
  type: LOAD_PRODUCT,
  latest: true,

  process({ requestUtil, action }, dispatch, done) {
    const idType = Number.isNaN(Number(action.id));
    const ROUTE = idType ? PRODUCT_URL_NEW_OPERATIONS : PRODUCT_URL;
    requestUtil(ROUTE.replace(':id', action.id))
      .then(async (response) => {
        if (!response) {
          window.location = '';
        } else if (!response.error || idType) {
          if (idType) {
            const normalizedProduct = await rubiYieldFormatter(response);
            dispatch(LoadProductSuccess(normalizedProduct));
          } else {
            const normalizedProduct = await normalizeProduct(response);
            dispatch(LoadProductSuccess(normalizedProduct));
          }
        } else {
          toastr.error('Erro ao carrregar operação', 'Tente novamente');
          dispatch(LoadProductError());
        }
      })
      .then(done);
  },
});
